import { render, staticRenderFns } from "./refer.vue?vue&type=template&id=9fdaebc2&scoped=true&lang=pug"
import script from "./refer.vue?vue&type=script&lang=ts"
export * from "./refer.vue?vue&type=script&lang=ts"
import style0 from "./refer.vue?vue&type=style&index=0&id=9fdaebc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdaebc2",
  null
  
)

export default component.exports